module.exports = __webpack_public_path__ + "static/media/logo.d4ac3226.png";